import type { ProductsData } from '@/app/api/search/products/createProductsData.ts';
import { getCoordinatesFromFeatureCollection } from '@/utils/mapUtils';
import type { FeatureCollection, Feature, Geometry, GeoJsonProperties } from 'geojson';
import type { DealCard } from '../../../../../utils/buildDealCards/dealCardTypes';
import getDotsGeoJSON from './getDotsGeoJSON';
import getMarkersDotsGeoJSON from './getMarkersDotsGeoJSON';

const combineFeatureCollections = (featureCollections: FeatureCollection[] = []): FeatureCollection => {
  const features = featureCollections.reduce(
    (result, featureCollection) => result.concat(featureCollection?.features || []),
    [] as Feature<Geometry, GeoJsonProperties>[]
  );
  return {
    type: 'FeatureCollection',
    features,
  };
};

type GetGeoJSON = {
  results: DealCard[];
  productsData: ProductsData;
};

const getAllGeoJSON = ({ results, productsData }: GetGeoJSON) => {
  const markersDotsGeoJSON: FeatureCollection = getMarkersDotsGeoJSON(results);
  const dotsGeoJSON = getDotsGeoJSON({ dots: productsData.dots, results });
  const combinedFeatures = combineFeatureCollections([markersDotsGeoJSON]);
  return {
    ...getCoordinatesFromFeatureCollection(combinedFeatures),
    dotsGeoJSON,
  };
};

export default getAllGeoJSON;
